import { render } from "./HomePageBenovium.vue?vue&type=template&id=249a4418"
import script from "./HomePageBenovium.vue?vue&type=script&lang=js"
export * from "./HomePageBenovium.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__